(() => {
  if (customElements.get('geyoto-stock-clarity')) return;
  const kits = {
    'KIT-1024-200': ['YS1800-01-EC', 1],
    'KIT-1024-400': ['YS1800-01-EC', 2],
    'KIT-1024-200-02': ['YS1800-02-EC', 1],
    'KIT-1024-400-02': ['YS1800-02-EC', 2],
    'YE1800E-BL-US-EC': ['YS1800-03BL-US-EC', 1],
    'YE1800F-BL-US-EC': ['YS1800-03BL-US-EC', 2]
  };
  class StockClarity extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-sc-config]').textContent);
      this.host = this.closest('.pdp-buybox');
      if (!this.host) return;
      this.extra = this.closest('.pdp-buybox__extras');
      this.defaultSplitDetail = this.querySelector('[data-sc-split-detail]').textContent;
      this.change = () => this.queue();
      this.host.addEventListener('change', this.change);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.queue();
      });
      this.observer.observe(this.extra, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class','value']});
      this.onPrice = () => this.queue();
      document.addEventListener('buybox:price-updated', this.onPrice);
      this.queue();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.host?.removeEventListener('change', this.change);
      document.removeEventListener('buybox:price-updated', this.onPrice);
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
    queue() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }
    text(selector, value) {
      const node = this.querySelector(selector);
      if (node && node.textContent !== value) node.textContent = value;
    }
    dateText(key, date) { return this.config.text[key].replace('__date__', date); }
    selected() {
      const id = this.host.querySelector('[data-selected-variant-id]')?.value;
      return this.config.variants.find(item => String(item.id) === String(id));
    }
    bySku(sku) { return this.config.variants.find(item => item.sku === sku); }
    nativeState() {
      const button = this.host.querySelector('[data-add-to-cart]');
      if (!button?.classList.contains('restock-rocket-preorder-button')) return null;
      const native = this.extra.querySelector('.restock-rocket-preorder-description');
      const dateText = native?.querySelector('.preorder-detail-text')?.textContent.trim();
      const payment = native?.querySelector('.preorder-description-text')?.textContent.trim();
      if (!dateText || !payment) return null;
      return {date:dateText.replace(/^[^:]+:\s*/, ''), payment, button};
    }
    reset() {
      this.hidden = true;
      this.host.removeAttribute('data-stock-clarity-native');
      this.setSticky(null);
    }
    update() {
      const variant = this.selected();
      if (!variant || !variant.available) { this.reset(); return; }
      const kit = kits[variant.sku];
      const state = this.nativeState();
      this.host.removeAttribute('data-stock-clarity-native');
      if (kit && state) {
        const station = this.bySku(kit[0]);
        const split = this.config.split && station?.available && station.stock > 0;
        this.renderPreorder(state, split, kit[1], station);
        return;
      }
      if (variant.sku === 'YP200-01-EC' && state) {
        this.renderPreorder(state, false, 1, null);
        return;
      }
      this.reset();
    }
    setMode(mode) {
      if (this.dataset.mode !== mode) {
        this.querySelectorAll('details').forEach(details => { details.open = false; });
        this.dataset.mode = mode;
      }
      this.hidden = false;
    }
    renderPreorder(state, split, count, station) {
      this.setMode(split ? 'split' : 'preorder');
      this.querySelector('[data-sc-power-row]').hidden = !split;
      const stationImage = this.querySelector('.geyoto-stock-clarity__station-image');
      if (stationImage && station?.image && stationImage.getAttribute('src') !== station.image) {
        stationImage.removeAttribute('srcset');
        stationImage.setAttribute('src',station.image);
      }
      this.text('[data-sc-badge]', this.config.text[split ? 'split_badge' : 'preorder_badge']);
      this.text('[data-sc-panel-label]', !split && station ? this.config.text.kit_label : this.config.text[count > 1 ? 'panel_two' : 'panel_one']);
      this.text('[data-sc-panel-date]', this.dateText('estimated',state.date));
      this.text('[data-sc-payment]', /^Full payment/i.test(state.payment) ? this.config.text.full_payment : state.payment);
      this.text('[data-sc-split-detail]', split ? this.defaultSplitDetail : this.config.text.kit_details);
      this.querySelector('[data-sc-split-detail]').hidden = !station && !split;
      this.host.setAttribute('data-stock-clarity-native','replaced');
      if (split) {
        const label = state.button.querySelector('[data-add-to-cart-label]') || state.button;
        if (label.textContent !== this.config.text.kit_button) label.textContent = this.config.text.kit_button;
      }
      this.setSticky(this.dateText(split ? 'sticky_split' : 'sticky_panel',state.date), split);
    }
    setSticky(message, split=false) {
      document.querySelectorAll('.sticky-product-bar__info-bar').forEach(node => {
        if (!node.dataset.stockClarityOriginal) node.dataset.stockClarityOriginal = node.textContent;
        const value = message || node.dataset.stockClarityOriginal;
        if (node.textContent !== value) node.textContent = value;
      });
      document.querySelectorAll('[data-sticky-add-to-cart]').forEach(button => {
        if (!button.dataset.stockClarityOriginal) button.dataset.stockClarityOriginal = button.textContent.trim();
        const value = split ? this.config.text.kit_button : button.dataset.stockClarityOriginal;
        if (button.textContent.trim() !== value) button.textContent = value;
      });
    }
  }
  customElements.define('geyoto-stock-clarity',StockClarity);
})();
